<!--
  - Copyright (c) 2021. Michael Clovis
  - This program is free software: you can redistribute it and/or modify
  -     it under the terms of the GNU Affero General Public License as published by
  -     the Free Software Foundation, either version 3 of the License, or
  -     (at your option) any later version.
  -
  -     This program is distributed in the hope that it will be useful,
  -     but WITHOUT ANY WARRANTY; without even the implied warranty of
  -     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  -     GNU Affero General Public License for more details.
  -
  -     You should have received a copy of the GNU Affero General Public License
  -     along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<template>

  <td @click="addRota" class="col-3">
    <div @click="(e) => {
     this.editRota(e, idx)}" v-for="(rota,idx) in dRota" :key="rota" :id="rota" class="col-12 rectangle"
         :style="getColor(rota)">
      <div class="row">
        <div class="col-12">
          <span v-if="rota.checkin.display_name!==''">
            <a href="#" @click="(e) =>{this.showMapModal(e,idx)}" title="Click To View Map ">{{
                rota.job
              }}</a>
          </span>
          <span v-else>
            {{ rota.job }}
          </span>

          <span v-if="showPay">&nbsp;{{ employee.calculatePayForRota(rota, jobs) }}</span>
          <span v-else>&nbsp;&nbsp;&nbsp;</span>
        </div>
        <div class="row">
        <div class="col-12">{{ rota.getDurationStart() }} - {{ rota.getDurationEnd() }}</div>
        </div>
        <div class="row">
          <div class="col-12">
            {{ new TimeCard(rota.validateCheckin,rota.clockOut).getHoursWorked()}} time clock hours
          </div>
        </div>

      </div>
    </div>

  </td>


</template>

<script>
import {Appointment} from "../classes/Appointment";
import {TimeCard} from "../classes/TimeCard";

export default {
  name: "ScheduleItem",
  watch: {
    rota: {
      deep: true,
      handler() {

        this.setDrota();
      },


    }
  },
  mounted() {
    this.setDrota();
  },
  props: {
    employee: {
      type: Object,
      required: true,
    },
    moment: {
      type: Object,
      required: true,
    },
    rota: {
      type: Array,
      required: true,
    },
    showPay: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["rotachosen", "choosetoday", "show-map"],
  data() {
    return {
      dRota: [],
      addClicked: false,

    }
  },
  computed: {
    TimeCard() {
      return TimeCard
    },
    jobs() {
      return this.$store.state.jobs;
    },
    users() {
      return this.$store.state.users;
    },
  },
  methods: {
    getColor(rota) {
      if (rota.isValidated) {
        return {color: "green"};
      } else if (rota.validateCheckin.lat !== "0") {
        return {color: "red"};
      } else {
        return {};
      }
    },
    showMapModal(evt, idx) {
      evt.stopImmediatePropagation();
      this.$emit("show-map", this.dRota[idx]);
    },

    addRota(evt) {
      evt.stopImmediatePropagation();

      let rota = new Appointment();
      rota.User = this.employee;

      this.$emit("choosetoday", this.moment.startOf('day'));
      this.$emit("rotachosen", rota);
    },

    editRota(evt, idx) {
      evt.stopImmediatePropagation();

      this.$emit("rotachosen", this.dRota[idx]);
    },
    setDrota() {
      this.dRota = [];
      let sortByStartTime = (a, b) => {
        return a.duration.start.unix() >= b.duration.start.unix() ? 1 : -1;
      }
      let rotaArray = this.rota.slice();
      rotaArray.sort(sortByStartTime);
      // console.log("rota array length:")
      // console.log(rotaArray.length)

      while (rotaArray.length > 0) {

        if (rotaArray[0].isSameDayAndSameUser(this.employee, this.moment)) {
          //console.log("getting a rota")
          let r = rotaArray.splice(0, 1);

          this.dRota.push(r[0]);
        } else {
          rotaArray.splice(0, 1);
        }

      }
      //console.log("rota after dRota: "+this.rota.length)
    },

  },

}
</script>

<style scoped>


  .rectangle {

  //display: inline-block; //height:50px; //width: 100%; float: none;
  //padding-right: 100%; position: relative;
    background-color: white;
    border: black 3px solid;

  }
</style>
